import { useEffect } from "react";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import "../node_modules/react-toastify/dist/ReactToastify.css";
import "../node_modules/bootstrap-daterangepicker/daterangepicker.css";
import ReactTooltip from "react-tooltip";
import Routes from "./components/routes";
import { useDispatch, useSelector } from "react-redux";
import { getCreditsByPlanHandler, getUserProfileHandler } from "./redux/User/userDetails.action";
import { includePendo, includeSentry } from "./utils/utils";
import { getSidebarCountData } from "@redux/Sidebar/sidebarCount.action";
import ErrorBoundary from "@components/ErrorBoundary";
import CacheBuster from "react-cache-buster";
import packageInfo from "../package.json";
import LoaderImg from "../src/assets/images/loader.gif";
import { v4 as uuidv4 } from "uuid";
import LocalStorageService from "@core/services/local-storage.service";
import SessionStorageService from "@core/services/session-storage.service";
const localStorageService = LocalStorageService.getService();
const sessionStorageService = SessionStorageService.getService();
const App = () => {
  const dispatch = useDispatch();
  const { userData, creditDetails, userToken } = useSelector((state) => state.userDetails);

  const handleClick = () => {
    let input = document.getElementById("dropdownMenuButton");
    let val2 = document.getElementById("onClickClear");
    if (input && val2) {
      input.classList.remove("show");
      val2.classList.remove("show");
    }
  };

  useEffect(() => {
    if (import.meta.env.VITE_HOST_ENV === "production" && userData && Object.keys(userData).length) {
      includeSentry({ email: userData?.email, name: userData?.fullName });
      includePendo(userData.email, userData.organizationName);
    }
  }, [userData]);

  useEffect(() => {
    if (!Object.keys(userData).length && Object.keys(userToken).length) {
      dispatch(getUserProfileHandler());
      dispatch(getSidebarCountData());
    }
  }, [userToken]);

  useEffect(() => {
    if (!Object.keys(creditDetails)?.length && !creditDetails.dataSourceList && Object.keys(userToken).length) {
      dispatch(getCreditsByPlanHandler());
    }
  }, [userToken]);

  useEffect(() => {
    let tabUniqueId = uuidv4();
    window.addEventListener("load", () => {
      let tabIds = localStorageService.getActiveTabIds() || [];
      if (tabIds && Array.isArray(tabIds) && tabIds.length > 0) {
        sessionStorageService.setShowReloadLastSearchModal(false);
        tabIds.push(tabUniqueId);
      } else {
        if (sessionStorageService.getShowReloadLastSearchModal() === null) {
          sessionStorageService.setShowReloadLastSearchModal(true);
        }
        tabIds = [tabUniqueId];
      }
      localStorageService.setActiveTabIds(tabIds);
    });
    window.addEventListener("beforeunload", () => {
      let tabIds = localStorageService.getActiveTabIds();
      if (tabIds && Array.isArray(tabIds) && tabIds.includes(tabUniqueId)) {
        tabIds.splice(tabIds.indexOf(tabUniqueId), 1);
        localStorageService.setActiveTabIds(tabIds);
      }
    });
  }, []);

  return (
    <ErrorBoundary>
      <CacheBuster
        currentVersion={packageInfo.version}
        isEnabled={true} // If false, the library is disabled.
        isVerboseMode={false} // If true, the library writes verbose logs to console.
        loadingComponent={
          <div className="loader-container">
            <div className="loader-block">
              <img src={LoaderImg} alt="description of gif" />
            </div>
          </div>
        } // If not pass, nothing appears at the time of new version check.
      >
        <div onClick={handleClick}>
          <ReactTooltip />
          <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick={true} rtl={false} pauseOnFocusLoss pauseOnHover limit={1} theme="colored" />
          <Routes />
        </div>
      </CacheBuster>
    </ErrorBoundary>
  );
};

export default App;
